import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "../controls/Icon";
import useNavbar from "../../common/Navbar";

const VerticalNavbar = () => {
    const [translate] = useTranslation();
    const { objectType } = useParams();
    const {
        handleDomainManagementClick,
        handleDeploymentClick,
        handleDrillDownClick,
        selectedTab,
        deployments,
        drillDownObjects,
        next,
        previous,
        hasNextPage,
        currentPage,
        isRootDomain
    } = useNavbar();

    const verticalDrillDownHeader = useMemo(() => {
        if (!selectedTab) {
            return <></>
        }
        return (
            drillDownObjects.map((element, index) => (
                element.visible &&
                <button key={element.id}
                    className={`list-group-item list-group-item-action small text-end ${objectType === element.id ? "active" : ""}`}
                    onClick={() => handleDrillDownClick(element.id, selectedTab._id)}
                >{element.name}</button>
            ))
        );
    }, [selectedTab, handleDrillDownClick, drillDownObjects, objectType]);

    const rootDomainVerticalHeader = useMemo(() => {
        return (
            <div className="card mb-3">
                <div className="card-body">
                    <div className="list-group">
                        {drillDownObjects.map((element, index) => (
                            element.visible &&
                            <button key={element.id}
                                className={`list-group-item list-group-item-action small ${objectType === element.id ? "active" : ""}`}
                                onClick={() => handleDrillDownClick(element.id, selectedTab._id)}
                            >{element.name}</button>
                        ))}
                    </div>
                </div>
            </div>
        );
    }, [drillDownObjects, handleDrillDownClick, objectType, selectedTab])

    const verticalHeader = useMemo(() => {
        return (
            <div className="card mb-3">
                <div className="card-body">
                    <div className="list-group">
                        <button key={0}
                            className={`list-group-item list-group-item-action small ${selectedTab === "domain-management" ? `active opacity-50` : ""}`}
                            onClick={() => handleDomainManagementClick()}
                        >{translate("OTM_DOMAIN_MANAGEMENT")}</button>

                        {selectedTab === "domain-management" && verticalDrillDownHeader}

                        <button key={1}
                            className={`list-group-item list-group-item-action small`}
                            onClick={previous}
                            hidden={currentPage === 1}
                        ><Icon icon="ChevronUp" className="d-block"></Icon></button>

                        {deployments.map((deployment, index) => {
                            return (
                                <React.Fragment key={deployment._id}>
                                    <button
                                        className={`list-group-item list-group-item-action small ${selectedTab?._id === deployment._id ? `active ${selectedTab._id !== null ? "opacity-50" : ""}` : ""}`}
                                        onClick={() => handleDeploymentClick(deployment)}
                                    >{deployment.name}</button>
                                    {selectedTab?._id === deployment._id && verticalDrillDownHeader}
                                </React.Fragment>
                            )
                        })}

                        <button key={2}
                            className={`list-group-item list-group-item-action small`}
                            onClick={next}
                            hidden={!hasNextPage}
                        ><Icon icon="ChevronDown" className="d-block"></Icon></button>
                    </div>
                </div>
            </div>
        );
    }, [translate, deployments, next, previous, hasNextPage, currentPage, handleDomainManagementClick, handleDeploymentClick, selectedTab, verticalDrillDownHeader])

    return (
        <>
            {!isRootDomain && verticalHeader}
            {isRootDomain && rootDomainVerticalHeader}
        </>
    );
};

export default VerticalNavbar;